import { FeatureCollection, MultiPolygon } from "@turf/turf";
import React from "react";
import { Layer, LayerProps, Source } from "react-map-gl";

const schoolLineColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--ll-color-on-background");

const schoolLayerStyle: LayerProps = {
  id: "school",
  type: "line",
  source: "schoolCatchment",
  paint: {
    "line-width": 3,
    "line-color": schoolLineColor,
  },
};

type SchoolCatchmentProps = {
  schoolCatchment: FeatureCollection<MultiPolygon>;
};

const SchoolCatchment = (props: SchoolCatchmentProps) => (
  <Source type="geojson" data={props.schoolCatchment}>
    <Layer {...schoolLayerStyle} />
  </Source>
);

export default SchoolCatchment;
